import type { IContact } from 'src/types/IContact';
import type { IContactsPayload } from 'src/types/IContactsPayload';

export function getContactsDiff(
  newContacts: IContact[],
  oldContacts: { id: string; referenceCount: number }[]
): IContactsPayload {
  const removedContacts = oldContacts.reduce((acc, curr) => {
    if (!newContacts.some((newContact) => newContact.id === curr.id)) {
      acc.push(curr.id);
    }

    return acc;
  }, [] as string[]);

  const addedContacts = newContacts.filter((newContact) => !newContact.id);
  const updatedContacts = newContacts.filter(
    (newContact) =>
      !!newContact.id && (oldContacts.find((oldContact) => oldContact.id === newContact.id)?.referenceCount ?? 2) < 2
  );

  return {
    addedContacts,
    updatedContacts,
    removedContacts,
  };
}
